import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "EcIAJl",
    defaultMessage: "Edit variant assignments",
    description: "dialog header",
  },
  description: {
    id: "zc82T9",
    defaultMessage:
      "Select the variants that should display this image. Leave all unchecked to keep it as a shared product image.",
    description: "dialog description",
  },
  noVariants: {
    id: "dp3epJ",
    defaultMessage: "This product has no variants.",
    description: "empty state",
  },
});
